var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parsed-link-component" },
    _vm._l(_vm.filtered_links, function(link) {
      return _c("LinkInfoShort", {
        key: link.$index,
        attrs: { link: link, with_delete: _vm.editable },
        on: {
          delete: function($event) {
            return _vm.deleteLink(link)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }